export default __webpack_public_path__ + "static/media/SackBasicsNylon.65d03445.jpg";